import React, { useMemo } from 'react';

import {
	type ButtonComponent as LoomPluginButtonComponent,
	type LoomPluginOptions,
} from '@atlaskit/editor-plugins/loom';

import { useLoomEntryPointVariant } from '@confluence/loom-utils';
import { useBooleanFeatureFlag } from '@confluence/session-data';

import { EditorLoomButton } from '../EditorLoomButton';

type UseLoomPlugin = {
	isPluginEnabled: boolean;
	pluginOptions: LoomPluginOptions;
};

export const useLoomPluginOptions = (): UseLoomPlugin => {
	const entryPointVariant = useLoomEntryPointVariant();
	const isLoomPluginEnabled = useBooleanFeatureFlag(
		'confluence.frontend.fabric.provider.loom.editor_h5h46',
	);
	const isPluginEnabled = isLoomPluginEnabled && entryPointVariant !== 'DISABLED';

	const pluginOptions = useMemo(() => {
		return {
			renderButton: (ButtonComponent: LoomPluginButtonComponent) => {
				return <EditorLoomButton buttonComponent={ButtonComponent} />;
			},
		};
		// Intentionally not recreating/updating the plugin options in order to remain consistent with
		// the behavior of the editor preset that uses this hook to generate the loom plugin options
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { isPluginEnabled, pluginOptions };
};
